document.addEventListener("DOMContentLoaded", function() {
  //js button click
  var keepMenuOpen = function keepMenuOpen() {
    if (!document.body.classList.contains('show-sidebar-main')) {
      document.body.classList.add('show-sidebar-main');
      document.body.classList.add('active');
      console.log('Menu opened');
    }
  }; //close mobile menu

  var keepMenuClosed = function keepMenuClosed() {
    if (document.body.classList.contains('show-sidebar-main')) {
      document.body.classList.remove('show-sidebar-main');
      document.body.classList.remove('active');
      var menuOverlay = document.querySelector('.menu-popup-background');

      if (menuOverlay) {
        menuOverlay.remove();
      }

      console.log('Menu closed');
    }
  }; //create menu overlay

  document.querySelector('li.js-menu-toggle-home').onclick = function (e) {
    keepMenuOpen();
  }; //keep menu open when clicking inside sidebar

  document.querySelector('#aside_main').onclick = function (e) {
    document.body.removeEventListener('click', closeSidebar);
    var closeBtn = document.querySelector("#aside_main .js-close-menu");
    var target = e.target;
    keepMenuOpen();
    if(target.closest("#aside_main .js-close-menu") == closeBtn) {
      keepMenuClosed();
    }
  }; //close sidebar when clicked on overlay

  var closeSidebar = function closeSidebar(e) {
    passive: true;

    var container = document.querySelector("#aside_main");
    var $body = document.body;

    if (!(container.classList[0] === e.target.classList[0]) && container.querySelector(e.target.classList[0]) == null) {
      if ($body.classList.contains('show-sidebar-main')) {
        keepMenuClosed();
      }
    }
  }; //invoke event listeners

  var closeBtn = document.querySelector("#aside_main .js-close-menu");
  closeBtn.onclick = function (e) {
    keepMenuClosed();
    console.log('test');
  };
});
